var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.selection
    ? _c(
        "div",
        {
          staticClass: "selection-wapper",
          class: [
            "selection-data",
            _vm.priceChange,
            {
              "longprice-selection":
                _vm.formatedSelectionPrice &&
                _vm.formatedSelectionPrice.length > _vm.selectionLength
            },
            {
              withhcp:
                _vm.selection.currenthandicap ||
                (_vm.selection.currenthandicap === 0 &&
                  ["H", "D", "A"].indexOf(_vm.selection.hadvalue) > -1)
            },
            { "no-price": !_vm.formatedSelectionPrice },
            {
              "not-tradable":
                !_vm.istradable ||
                _vm.selection.idfobolifestate === "NR" ||
                _vm.selectionHasSuspensionPerBusinessChannel
            },
            { "sel-H": _vm.selection.hadvalue === "H" },
            { "sel-D": _vm.selection.hadvalue === "D" },
            { "sel-A": _vm.selection.hadvalue === "A" },
            { "sel-O": _vm.selection.hadvalue === "O" },
            { "sel-U": _vm.selection.hadvalue === "U" }
          ],
          attrs: {
            idfoselection:
              (_vm.selection &&
                _vm.selection.idfoselection &&
                _vm.selection.idfoselection.toString()) ||
              "null"
          }
        },
        [
          _vm.showselectionname
            ? _c(
                "div",
                {
                  staticClass: "name names",
                  class: { "show-one-in-one-line": _vm.showOneInOneLine }
                },
                [_vm._v(_vm._s(_vm.selection.name))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "value",
              class: {
                "show-one-in-one-line": _vm.showOneInOneLine,
                suspended:
                  !_vm.istradable ||
                  _vm.selection.idfobolifestate === "NR" ||
                  _vm.selectionHasSuspensionPerBusinessChannel
              }
            },
            [
              _c("div", { staticClass: "sh" }, [
                _vm.selection.currenthandicap ||
                (_vm.selection.currenthandicap === 0 &&
                  ["H", "D", "A"].indexOf(_vm.selection.hadvalue) > -1)
                  ? _c(
                      "div",
                      {
                        class: [
                          "currenthandicap",
                          {
                            "long-h cp":
                              _vm.selection.currenthandicap.toString().length >
                              3
                          }
                        ]
                      },
                      [
                        ["O", "U"].indexOf(_vm.selection.hadvalue) > -1
                          ? _c("div", { staticClass: "had-value" }, [
                              _vm.selection.hadvalue == "O" && !_vm.flashbetting
                                ? _c("span", [_vm._v("O")])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.selection.hadvalue == "O" && _vm.flashbetting
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.selection.name))
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.selection.hadvalue == "U" && !_vm.flashbetting
                                ? _c("span", [_vm._v("U")])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.selection.hadvalue == "U" && _vm.flashbetting
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.selection.name))
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        ["O", "U"].indexOf(_vm.selection.hadvalue) > -1
                          ? _c("div", { staticClass: "uo-currenthandicap" }, [
                              _vm._v(_vm._s(_vm.selection.currenthandicap))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        ["H", "D"].indexOf(_vm.selection.hadvalue) > -1
                          ? _c("div", { staticClass: "currenthandicap" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.handicapFormatted) +
                                  "\n        "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        ["A"].indexOf(_vm.selection.hadvalue) > -1
                          ? _c("div", { staticClass: "currenthandicap" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.handicapFormatted) +
                                  "\n        "
                              )
                            ])
                          : _vm._e()
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.istradable &&
                _vm.selection.idfobolifestate !== "NR" &&
                !_vm.selectionHasSuspensionPerBusinessChannel
                  ? _c(
                      "div",
                      {
                        staticClass: "selectionprice",
                        class: {
                          noprice: !_vm.formatedSelectionPrice,
                          longprice:
                            _vm.formatedSelectionPrice &&
                            _vm.formatedSelectionPrice.length >
                              _vm.selectionLength,
                          varylongprice:
                            _vm.formatedSelectionPrice &&
                            _vm.formatedSelectionPrice.length >
                              _vm.secondselectionLength,
                          veryvarylongprice:
                            _vm.formatedSelectionPrice &&
                            _vm.formatedSelectionPrice.length >
                              _vm.thirdSelectionLength
                        }
                      },
                      [_vm._v(_vm._s(_vm.formatedSelectionPrice || "--"))]
                    )
                  : _c(
                      "div",
                      { staticClass: "selectionprice suspended" },
                      [_c("v-icon", [_vm._v("lock_open")])],
                      1
                    )
              ])
            ]
          ),
          _vm._v(" "),
          _vm.isDebug
            ? _c("div", { staticStyle: { "font-size": "10px" } }, [
                _vm._v(
                  "\n    had " +
                    _vm._s(_vm.selection.hadvalue || "--") +
                    "\n    io " +
                    _vm._s(_vm.selection.internalorder || "--")
                ),
                _c("br"),
                _vm._v(
                  "\n    ch " +
                    _vm._s(_vm.selection.currenthandicap || "--") +
                    "\n    p " +
                    _vm._s(
                      (_vm.selection.price && _vm.selection.price.toFixed(2)) ||
                        "--"
                    ) +
                    "\n  "
                )
              ])
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f128c6a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f128c6a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/selection.vue
// module id = null
// module chunks = 